import createLucideIcon from '../createLucideIcon';

const ArrowBigUp = createLucideIcon('ArrowBigUpIcon', [
  ['path', { d: 'M9 21V10H5l7-7 7 7h-4v11z', key: '8tfmm3' }],
]);

export default ArrowBigUp;
